import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { InputComponent } from 'src/app/components/shared/input';
import { CategoryService } from 'src/app/services/category';
import { LocaleService } from 'src/app/services/locale';
import { DropdownComponent } from '../../../../shared/dropdown';
import { TrashComponent } from '../../../../icons/trash';
import { PlusComponent } from '../../../../icons/plus';

@Component({
  selector: 'app-category1-question5',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputComponent,
    DropdownComponent,
    TrashComponent,
    PlusComponent
  ],
  template: `
    <div
      *ngFor="
        let question of [
          strings[language].question,
          strings[language].question2
        ];
        let i = index
      "
    >
      <div class="text-[13px]">
        {{ question }}
      </div>
      <div class="text-[12px] text-[#616161] mt-1">
        {{ strings[language].answer }}
      </div>
      <br />
      <div class="flex flex-wrap gap-4 sm:gap-6">
        <div
          (click)="selectYes(i)"
          class="flex gap-2 align-middle items-center cursor-pointer text-[13px]"
        >
          <div
            [ngClass]="{
              'bg-[#183A25]':
                i === 0 ? question0usage : i === 1 ? question1usage : null
            }"
            class="w-4 h-4 border border-gray-500 rounded-full flex-shrink-0"
          ></div>
          <div>{{ strings[language].choice_yes }}</div>
        </div>
        <div>
          <div
            (click)="selectNo(i)"
            class="flex gap-2 align-middle items-center cursor-pointer text-[13px]"
          >
            <div
              [ngClass]="{
                'bg-[#183A25]':
                  i === 0 ? !question0usage : i === 1 ? !question1usage : null
              }"
              class="w-4 h-4 border border-gray-500 rounded-full flex-shrink-0"
            ></div>
            <div>{{ strings[language].choice_no }}</div>
          </div>
        </div>
      </div>
      <div *ngIf="i === 0 && question0usage" class="mt-5">
        <div
          class="bg-[#043B22] flex px-3 py-2.5 rounded-t-lg gap-4 mt-6 items-center"
        >
          <div class="text-white text-[13px] flex-1">
            {{ strings[language].label_1 }}
          </div>
          <div class="text-white text-[13px] flex-1">
            {{ strings[language].label_2 }}
          </div>
          <div class="text-white text-[13px] flex-1">
            {{ strings[language].label_3 }}
          </div>
          <div
            (click)="createForm(0)"
            class="w-6 h-6 flex justify-center items-center cursor-pointer bg-white/20 hover:bg-white/30 rounded-full transition-colors"
          >
            <app-plus color="white"></app-plus>
          </div>
        </div>
        <div
          *ngFor="let gasType of q0GasTypeControls; let x = index"
          class="flex py-4 px-1 border-y border-[#DEE2E6] gap-5"
        >
          <div class="w-1/2">
            <app-input
              [index]="x"
              type="number"
              [dollar]="false"
              placeholder="0.00"
              (keyup)="onKeyUp()"
              [control]="gasType.row['refill']"
            >
            </app-input>
          </div>

          <div class="w-1/2">
            <app-dropdown
              placeholder="{{ strings[language].select }} {{
                strings[language].label_2
              }}"
              [options]="gasOptionsQ0"
              [control]="gasType.row['gas']"
            ></app-dropdown>
          </div>

          <div class="w-1/2">
            <app-input
              type="number"
              [dollar]="false"
              unit="Kg"
              placeholder="0.00"
              [keyUp]="onKeyUp"
              [control]="gasType.row['recharge']"
            >
            </app-input>
          </div>
          <div
            (click)="q0GasTypeControls.pop()"
            class="w-1/9 flex justify-end pr-2 align-middle items-center cursor-pointer"
          >
            <app-trash></app-trash>
          </div>
        </div>
      </div>
      <div *ngIf="i === 1 && question1usage" class="mt-5">
        <div
          class="bg-[#043B22] flex px-3 py-2.5 rounded-t-lg gap-4 mt-6 items-center"
        >
          <div class="text-white text-[13px] flex-1">
            {{ strings[language].label_1 }}
          </div>
          <div class="text-white text-[13px] flex-1">
            {{ strings[language].label_2 }}
          </div>
          <div class="text-white text-[13px] flex-1">
            {{ strings[language].label_3 }}
          </div>
          <div
            (click)="createForm(1)"
            class="w-6 h-6 flex justify-center items-center cursor-pointer bg-white/20 hover:bg-white/30 rounded-full transition-colors"
          >
            <app-plus color="white"></app-plus>
          </div>
        </div>
        <div
          *ngFor="let gasType of q1GasTypeControls; let x = index"
          class="flex py-4 px-1 border-y border-[#DEE2E6] gap-5"
        >
          <div class="w-1/2">
            <app-input
              [index]="x"
              type="number"
              [dollar]="false"
              placeholder="0.00"
              (keyup)="onKeyUp()"
              [control]="gasType.row['refill']"
            >
            </app-input>
          </div>

          <div class="w-1/2">
            <app-dropdown
              placeholder="{{ strings[language].select }} {{
                strings[language].label_2
              }}"
              [options]="gasOptionsQ1"
              [control]="gasType.row['gas']"
            ></app-dropdown>
          </div>

          <div class="w-1/2">
            <app-input
              type="number"
              [dollar]="false"
              unit="Kg"
              placeholder="0.00"
              [keyUp]="onKeyUp"
              [control]="gasType.row['recharge']"
            >
            </app-input>
          </div>
          <div
            (click)="q1GasTypeControls.pop()"
            class="w-1/9 flex justify-end pr-2 align-middle items-center cursor-pointer"
          >
            <app-trash></app-trash>
          </div>
        </div>
      </div>
      <br />
    </div>
  `
})
export class Category1Question5Component {
  language = inject(LocaleService).getLanguage();
  categoryService = inject(CategoryService);
  categories = this.categoryService.categories();

  question0usage = false;
  question1usage = false;
  gasOptionsQ0 = [
    { value: 'fugitive_gas-type_hfc_23', label: 'HFC-23' },
    { value: 'fugitive_gas-type_hfc_236fa', label: 'HFC-236fa' },
    { value: 'fugitive_gas-type_hfc_143a', label: 'HFC-143a' },
    { value: 'fugitive_gas-type_hfc_32', label: 'HFC-32' },
    { value: 'fugitive_gas-type_hfc_134a', label: 'HFC-134a' },
    { value: 'fugitive_gas-type_hfc_227ea', label: 'HFC-227ea' },
    { value: 'fugitive_gas-type_hfc_125', label: 'HFC-125' },
    { value: 'fugitive_gas-type_r744', label: 'R-744 (CO₂)' },
    { value: 'fugitive_gas-type_r290_propane', label: 'R-290 (Propane)' },
    {
      value: 'fugitive_gas-type_hcfc_22r22_chlorodifluoromethane',
      label: 'R-22'
    }
  ];

  gasOptionsQ1 = [
    { value: 'fugitive_gas-type_hfc_23', label: 'HFC-23' },
    { value: 'fugitive_gas-type_hfc_236fa', label: 'HFC-236fa' },
    { value: 'fugitive_gas-type_hfc_143a', label: 'HFC-143a' },
    { value: 'fugitive_gas-type_hfc_134a', label: 'HFC-134a' },
    { value: 'fugitive_gas-type_hfc_125', label: 'HFC-125' },
    { value: 'fugitive_gas-type_hfc_152a', label: 'HFC-152a' },
    { value: 'fugitive_gas-type_hfc_227ea', label: 'HFC-227ea' },
    { value: 'fugitive_gas-type_r507a', label: 'R-507A' },
    { value: 'fugitive_gas-type_r744', label: 'R-744 (CO₂)' },
    { value: 'fugitive_gas-type_r717', label: 'R-717 (Ammonia, NH₃)' },
    { value: 'fugitive_gas-type_r404a', label: 'R-404A' }
  ];

  q0GasTypeControls = [
    {
      row: {
        refill: new FormControl('', Validators.required),
        gas: new FormControl('', Validators.required),
        recharge: new FormControl('', Validators.required),
        question: new FormControl(0)
      }
    }
  ];

  q1GasTypeControls = [
    {
      row: {
        refill: new FormControl('', Validators.required),
        gas: new FormControl('', Validators.required),
        recharge: new FormControl('', Validators.required),
        question: new FormControl(1)
      }
    }
  ];

  form = new FormGroup({
    rows: new FormControl(this.q0GasTypeControls.concat(this.q1GasTypeControls))
  });

  strings: any = {
    english: {
      question:
        'Indicate the use of air conditioning systems and specify the quantity of refrigerant gas used or disposed of annually.',
      answer: 'Please fill in the required data if yes to proceed.',
      choice_yes: 'Yes',
      choice_no: 'No',
      label_1: 'Refills',
      label_2: 'Gas',
      label_3: 'Kg / recharge',
      select: 'Select',
      question2:
        'Indicate the use of refrigeration systems (e.g., cold storage, commercial refrigeration) and specify the quantity of refrigerant gas used or disposed of annually.'
    },
    italian: {
      question:
        "Indicare l'uso degli impianti di condizionamento dell'aria e specificare la quantità di gas refrigerante utilizzato o smaltito annualmente.",
      answer:
        'Si prega di inserire i dati richiesti se la risposta è sì per procedere.',
      choice_yes: 'Sì',
      choice_no: 'No',
      label_1: 'Ricariche',
      label_2: 'Gas',
      label_3: 'Kg / ricarica',
      select: 'Seleziona',
      question2:
        "Indicare l'uso di sistemi di refrigerazione (ad esempio, celle frigorifere, refrigerazione commerciale) e specificare la quantità di gas refrigerante utilizzato o smaltito annualmente."
    }
  };

  ngOnInit() {
    let categories = localStorage.getItem('categories');

    if (categories) {
      categories = JSON.parse(categories);

      // @ts-ignore
      const answers = categories[0].questions[4].answers;

      if (answers?.length > 0) {
        let newControls: any = [];

        // @ts-ignore
        answers?.map((ex: any) => {
          newControls.push({
            row: {
              refill: new FormControl(ex.refill, Validators.required),
              gas: new FormControl(ex.gas, Validators.required),
              recharge: new FormControl(ex.recharge, Validators.required),
              question: new FormControl(ex.question)
            }
          });
        });

        this.q0GasTypeControls = newControls.filter(
          (ex: any) => ex.row.question.value === 0
        );

        if (this.q0GasTypeControls?.length > 0) {
          this.question0usage = true;
        }

        this.q1GasTypeControls = newControls.filter(
          (ex: any) => ex.row.question.value === 1
        );

        if (this.q1GasTypeControls?.length > 0) {
          this.question1usage = true;
        }

        this.form.setValue({ rows: newControls });
      }
    }
  }

  createForm = (index: any) => {
    if (index === 0) {
      this.q0GasTypeControls.push({
        row: {
          refill: new FormControl('', Validators.required),
          gas: new FormControl('', Validators.required),
          recharge: new FormControl('', Validators.required),
          question: new FormControl(0)
        }
      });
    } else {
      this.q1GasTypeControls.push({
        row: {
          refill: new FormControl('', Validators.required),
          gas: new FormControl('', Validators.required),
          recharge: new FormControl('', Validators.required),
          question: new FormControl(1)
        }
      });
    }

    this.form = new FormGroup({
      rows: new FormControl(
        this.q0GasTypeControls.concat(this.q1GasTypeControls)
      )
    });
  };

  onKeyUp = () => {
    let allOptions = [...this.gasOptionsQ0, ...this.gasOptionsQ1];

    let newAnswers = this.form.value.rows?.map(row => {
      const selectedValue = row.row.gas.value;
      const option = allOptions.find(opt => opt.value === selectedValue);

      return {
        refill: row.row.refill.value,
        gas: selectedValue,
        gas_label: option ? option.label : null,
        recharge: row.row.recharge.value,
        question: row.row.question.value
      };
    });

    this.categories[0].questions[4].answers = newAnswers as any;
    this.categoryService.persistCategories(this.categories);
  };

  selectYes(index: number) {
    if (index === 0) {
      this.question0usage = true;
      // Initialize controls if empty
      if (this.q0GasTypeControls.length === 0) {
        this.q0GasTypeControls = [
          {
            row: {
              refill: new FormControl('', Validators.required),
              gas: new FormControl('', Validators.required),
              recharge: new FormControl('', Validators.required),
              question: new FormControl(0)
            }
          }
        ];
      }
    } else {
      this.question1usage = true;
      // Initialize controls if empty
      if (this.q1GasTypeControls.length === 0) {
        this.q1GasTypeControls = [
          {
            row: {
              refill: new FormControl('', Validators.required),
              gas: new FormControl('', Validators.required),
              recharge: new FormControl('', Validators.required),
              question: new FormControl(1)
            }
          }
        ];
      }
    }
    this.form.setValue({
      rows: this.q0GasTypeControls.concat(this.q1GasTypeControls)
    });
    this.onKeyUp();
  }

  selectNo(index: number) {
    if (index === 0) {
      this.question0usage = false;
      this.q0GasTypeControls = [];
    } else {
      this.question1usage = false;
      this.q1GasTypeControls = [];
    }
    this.form.setValue({
      rows: this.q0GasTypeControls.concat(this.q1GasTypeControls)
    });
    this.onKeyUp();
  }
}
